import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TFilters} from './definitions';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.CASCADES_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const cascadesSlice = createSlice({
  name: 'cascades',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = cascadesSlice.actions;
export const selectFilters = (state: TRootState) => state.cascades.filters as TFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(EStorageKeys.CASCADES_FILTERS, JSON.stringify(action.payload));
  },
});

export default cascadesSlice.reducer;
